module.exports = __webpack_public_path__ + "static/media/picture-(22).1b53cbe3.JPG";